import React from "react";
import NumberFormat from "react-number-format";

export default function InputField(field) {
  let inputIcon;

  if (field.inputIcon) {
    inputIcon = field.inputIcon;
  }

  const errors = (field) => {
    const error = field.meta.error;
    const errorPresent = field.meta.touched && error;

    if (errorPresent && typeof error === "string") {
      return <div className="donation-error">{field.meta.error}</div>;
    } else if (errorPresent && Array.isArray(error) === true) {
      return (
        <div>
          {error.map((err, index) => (
            <div key={`${err}-${index}`} className="donation-error">
              {err}
            </div>
          ))}
        </div>
      );
    } else {
      return null;
    }
  };

  const renderInput = (field) => {
    if (field.isCurrency) {
      return (
        <NumberFormat
          thousandSeparator={true}
          decimalScale={2}
          allowNegative={false}
          displayType="input"
          type="text"
          isNumericString={true}
          aria-label={field["aria-label"]}
          className={field.inputClassName}
          placeholder={field.placeholder}
          {...field.input}
        />
      );
    } else {
      return (
        <input
          data-testid="t-InputFi-input"
          type={field.type}
          aria-label={field["aria-label"]}
          className={field.inputClassName}
          placeholder={field.placeholder}
          {...field.input}
        />
      );
    }
  };

  return (
    <div className={field.className}>
      {inputIcon}
      {renderInput(field)}
      {errors(field)}
    </div>
  );
}
